// All API requests and backend-hosted images use this configuration.
const config = window.CODEBRUH_CONFIG || {};
export const SERVER_URL = (config.serverUrl || "http://localhost:5001").replace(/\/$/, "");
export const API_BASE_URL = (config.apiBaseUrl || `${SERVER_URL}/api`).replace(/\/$/, "");
// Must match the Razorpay key pair your backend uses to create orders. See
// public/runtime-config.js for where to set this.
export const RAZORPAY_KEY_ID = config.razorpayKeyId || "";
